import { FC } from 'react'
import { Question } from './FAQ'
import { useCollabsibleItem } from 'services/Collapsible'

interface LgAnswerProps {
  id: string,
  groupId: string,
  item: Question,
}

const LgAnswer: FC<LgAnswerProps> = ({
  id,
  groupId,
  item: {
    question,
    content,
  }
}) => {
  const { collapsed } = useCollabsibleItem(groupId, id)

  return collapsed ? null : (
    <div className="my-4">
      <h2 className="mb-4">{question}</h2>
      <div>
        {content}
      </div>
    </div>
  )
}

export default LgAnswer
